import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {
  IReportResponse, IReportsTenantNotesParameterModel,
  IReportsTenantNotesResponseModel, IScheduleReportsResponseModel, IScheduledReportHistory, IUFModuleType, IscheduleReportsInput
} from 'src/app/Shared/models/ReportsModel';
import { AppService } from '../app.service';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})

export class ReportsService {
  private baseURL = this.appService.config.apiBaseUrl;
  pipe;
  isIncludeToday: boolean;

  constructor(private http: HttpClient,
    private appService: AppService) {
  }

  generateReport(ReportRequestModel: any): Observable<IReportResponse> {
    this.pipe = new DatePipe('en-US');
    let pdate = this.pipe.transform(new Date(), 'yyyy-MM-dd');
    let ptime = this.pipe.transform(new Date(), 'HH:mm:ss');
    ReportRequestModel["PrintedDate"] = pdate + 'T' + ptime;
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Reports/GenerateReport`;
    return this.http.post<IReportResponse>(url, ReportRequestModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getTenantNotesFilterList(reportsParameterModel: IReportsTenantNotesParameterModel): Observable<IReportsTenantNotesResponseModel[]> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Reports/GetTenantNotesFilterList`;
    return this.http.post<IReportsTenantNotesResponseModel[]>(url, reportsParameterModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getUserFunctionModuleDetails(): Observable<IUFModuleType[]> {
    return this.http.get<IUFModuleType[]>(
      `${this.baseURL}/UserGroups/GetAllModulesUserAuditTrailReport`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const contactInfo = res.body as IUFModuleType[];
          return contactInfo;
        }),
        catchError(this.handleError)
      );
  }

  GetScheduledReports(facilityId, scheduledReportFilter): Observable<IScheduleReportsResponseModel[]> {
    return this.http.get<IScheduleReportsResponseModel[]>(
      `${this.baseURL}/ScheduledReports/GetScheduledReports?facilityId=${facilityId}&scheduledReportFilter=${scheduledReportFilter}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const reports = res.body;
          return reports;
        }),
        catchError(this.handleError)
      );
  }


  GetScheduledReportsMatching(scheduleName): Observable<IScheduleReportsResponseModel[]> {
    return this.http.get<IScheduleReportsResponseModel[]>(
      `${this.baseURL}/ScheduledReports/GetScheduledReportsMatching?scheduleName=${scheduleName}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const reports = res.body;
          return reports;
        }),
        catchError(this.handleError)
      );
  }

  SaveScheduledReports(scheduleReportsInput: IscheduleReportsInput): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/ScheduledReports/SaveScheduledReports`;
    return this.http.post<any[]>(url, scheduleReportsInput, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  GetScheduledReportHistory(scheduleReportsId): Observable<IScheduledReportHistory[]> {
    return this.http.get<IScheduledReportHistory[]>(
      `${this.baseURL}/ScheduledReports/GetScheduledReportHistory?scheduleReportsId=${scheduleReportsId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const reports = res.body;
          return reports;
        }),
        catchError(this.handleError)
      );
  }

  DeleteScheduledReports(scheduleReportsId, facilityId): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }),};
    const url = `${this.baseURL}/ScheduledReports/DeleteScheduledReports?scheduleReportsId=${scheduleReportsId}&facilityId=${facilityId}`;
    return this.http.post<any>(url, options)
        .pipe(
            map(res => {
                return res;
            }),
            catchError(this.handleError)
        );
  }

  GetGenMSRCurrentDate(): Observable<boolean> {
    return this.http.get<any[]>(
      `${this.baseURL}/Reports/GetGenMSRCurrentDate`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}
